//
// Gas: kWh-bezogene Werte (Gasrechnung, CO2e-Tabellen) -> m³-bezogene Werte.
//
// Gaszähler zählen Volumen (m³), FRM rechnet CO2e und Kosten deshalb je m³
// (CDCDeviceManagement.applyCo2e/applyCost). Versorger und Emissionstabellen
// geben Gas aber je kWh an. Die Gasrechnung nennt den Umrechnungsfaktor:
//
//   kWh = m³ × Brennwert (kWh/m³) × Zustandszahl
//
// Also: Wert je m³ = Wert je kWh × Brennwert × Zustandszahl.
//
import { parseDecimalInput, isDecimalInput } from '@/utils/decimal-input'

// typische Werte H-Gas (nur Platzhalter in der Oberfläche, nie stillschweigend verwendet)
export const TYPICAL_CALORIFIC_VALUE = 11.2
export const TYPICAL_STATE_NUMBER = 0.95

// Umrechnungsfaktor kWh je m³ oder null, wenn die Eingaben unvollständig/ungültig sind
export function kwhPerCubicMeter (calorificValue, stateNumber) {
  if (!isDecimalInput(calorificValue) || !isDecimalInput(stateNumber)) return null
  const hs = parseDecimalInput(calorificValue)
  const z = parseDecimalInput(stateNumber)
  if (hs === null || z === null || !(hs > 0) || !(z > 0)) return null
  return hs * z
}

// je kWh -> je m³, gerundet auf 6 Nachkommastellen (Spaltengenauigkeit der Tabellen);
// leer bleibt leer (z.B. kein Arbeitspreis angegeben)
export function perKwhToPerCubicMeter (valuePerKwh, factor) {
  if (valuePerKwh === '' || valuePerKwh === null || valuePerKwh === undefined) return valuePerKwh
  if (!isDecimalInput(valuePerKwh) || !factor) return null
  const v = parseDecimalInput(valuePerKwh)
  return Math.round(v * factor * 1e6) / 1e6
}

// nachvollziehbarer Vermerk für die Beschreibung der Emission
export function conversionNote (co2ePerKwh, calorificValue, stateNumber) {
  const fmt = (n, d) => Number(n).toLocaleString('de-DE', { maximumFractionDigits: d })
  const hs = parseDecimalInput(calorificValue)
  const z = parseDecimalInput(stateNumber)
  return `umgerechnet aus ${fmt(parseDecimalInput(co2ePerKwh), 6)} kg/kWh, Brennwert ${fmt(hs, 3)} kWh/m³ × Zustandszahl ${fmt(z, 4)}`
}
